var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"main"}},[_c('img',{attrs:{"src":require("../../images/正在建设中.png"),"alt":""}}),_c('h2',[_vm._v("页面正在建设中...")])])}]

export { render, staticRenderFns }